module.exports = __webpack_public_path__ + "img/axle_conf_12.f977ac23.jpg";